import { KontaktItem } from './kontakt-item';

export class Kontaktdaten {
    public id: number;
    public name: string;
    public adresse?: string;
    public kontakte: KontaktItem[] = [];
}
